import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

/** Canonical assignable-user option (GET /api/users). */
export interface UserOption {
  id: string;
  display_name: string;
  role: string;
  department?: string;
  username?: string;
}

/**
 * Single canonical hook for the active-users dropdown source, shared by Leads,
 * Deals, Projects, Tasks and Activity. One query key (`['users','options']`)
 * → one cache → one GET /api/users regardless of how many surfaces are open.
 */
export function useUserOptions(enabled = true) {
  return useQuery({
    queryKey: ['users', 'options'],
    queryFn: async () => {
      const { data } = await api.get<{ users: UserOption[] }>('/api/users');
      return data.users ?? [];
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
